var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundAddButtoninline = function SvgRoundAddButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "-1 -1 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "current",
    stroke: "transparent",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "M9.5 15h11M15 9.5v11"
  })));
};
export default SvgRoundAddButtoninline;